import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const client = new ApolloClient({
  uri: process.env.REACT_APP_WORDPRESS_GRAPHQL || 'https://blog.quintbrothers.com/graphql',
  cache: new InMemoryCache(),
});

export default client;
